module.exports = __webpack_public_path__ + "static/media/mwesigwa-joel-jHvedTh-avo-unsplash2.d27d562b.jpg";